// ===== Capture Options Engine =====
// Generates ALL valid capture combinations for a played card, strictly
// following classic Scopa rules:
//  1. If one (or more) table cards have the SAME value as the played card,
//     the ONLY legal captures are those single cards (priority rule).
//     Each matching single card is offered as a separate option.
//  2. Otherwise, every subset of table cards whose values SUM to the played
//     card value is a legal capture option (each presented separately).
//  3. If neither exists -> no capture (card is played to the table).

function subsetsSummingTo(cards, target) {
  const results = [];
  const n = cards.length;
  for (let mask = 1; mask < (1 << n); mask++) {
    let sum = 0;
    const subset = [];
    for (let i = 0; i < n; i++) {
      if (mask & (1 << i)) {
        sum += cards[i].value;
        subset.push(cards[i]);
      }
    }
    if (sum === target) results.push(subset);
  }
  return results;
}

// Returns an array of options. Each option is an array of table cards to capture.
// An empty array means "no valid capture -> discard to table".
export function getCaptureOptions(playedCard, table) {
  const sameValue = table.filter((c) => c.value === playedCard.value);
  if (sameValue.length > 0) {
    // Priority rule: must take a single card of equal value.
    return sameValue.map((c) => [c]);
  }
  // Only combinations of 2+ cards can remain here (no single equals the value).
  return subsetsSummingTo(table, playedCard.value).filter((s) => s.length >= 2);
}
